const FAQ_ITEMS = [
  {
    q: '甜柚漫画是否真的完全免费？',
    a: '是的！甜柚漫画上的所有漫画作品均为免费阅读，无需付费订阅或购买。我们致力于为漫画爱好者提供优质的免费阅读体验。',
  },
  {
    q: '如何找到我喜欢的漫画类型？',
    a: '你可以通过首页的分类导航、人气榜单或搜索功能快速找到喜欢的漫画。我们还提供智能推荐引擎，根据你的阅读历史推荐相似作品。',
  },
  {
    q: '漫画更新频率是什么样的？',
    a: '热门连载漫画每日更新，其他作品根据作者发布节奏同步更新。你可以关注"最近更新"模块，随时查看最新上线的漫画话数。',
  },
  {
    q: '如何投稿原创漫画到甜柚漫画？',
    a: '欢迎原创漫画作者通过"投稿联系"模块与我们取得联系。请准备好作品简介和样章，我们的编辑团队会在收到后尽快回复。',
  },
  {
    q: '支持哪些设备阅读？',
    a: '甜柚漫画支持手机、平板和电脑等多种设备。你可以通过浏览器直接访问，也可以下载甜柚漫画APP获得更流畅的移动阅读体验。',
  },
  {
    q: '阅读记录会保存吗？',
    a: '登录账号后，你的阅读历史、收藏和订阅都会自动保存，方便随时续读。在不同设备上登录同一账号也能同步阅读进度。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="section-padding bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-foreground-600 mt-2 text-sm md:text-base">关于甜柚漫画的常见疑问解答</p>
        </div>

        <div className="max-w-3xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-4">
          {FAQ_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="p-5 rounded-2xl bg-background-50 border border-background-200/70"
            >
              <h3 className="text-sm font-bold text-foreground-900 mb-2 flex items-start gap-2">
                <span className="text-primary-500 shrink-0">Q:</span>
                {item.q}
              </h3>
              <p className="text-xs text-foreground-600 leading-relaxed flex items-start gap-2">
                <span className="text-accent-500 shrink-0">A:</span>
                {item.a}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}